import styled from "@emotion/styled"
import { useNavigation } from "contexts/Navigation"
import { fullGrid } from "css/grid"
import * as uniform from "@uniformdev/context-react"

const Root = styled.section`
  ${fullGrid}
  padding-block: 1.875rem 0.9375rem;

  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 0.625rem;
    grid-column: main;
    justify-content: center;
  }

  li {
    align-items: center;
    color: rgb(var(--light-black));
    display: flex;
    font-size: clamp(0.75rem, 0.625rem + 0.3125vw, 1rem);
    font-weight: normal;
    line-height: 1.375;
    list-style: none;
    white-space: nowrap;

    &:not(:last-child)::after {
      content: "-";
      margin-inline-start: 0.625rem;
    }
  }

  a {
    color: inherit;
    text-decoration: none;

    @media (hover: hover) {
      :hover {
        color: rgb(var(--green));
      }
    }
  }
`

export default function Legal({ legal_links }) {
  const navigation = useNavigation()
  const scores = uniform.useScores()

  return (
    <Root>
      <ul>
        {(legal_links || []).map(({ p13n, link: { label, href, external } }, index) => {
          if (p13n?.length) {
            for (const rule of p13n) {
              if (!rule.criteria?.name?.crit) {
                break
              }

              const hit = rule.criteria.name.crit.every(crit => {
                const { l: signal, op: operator, r: value } = crit

                switch (operator) {
                  case "=":
                    return +scores[signal] === +value
                  default:
                    return false
                }
              })

              if (rule.type === "include") {
                if (hit) continue
                else return null
              }

              if (rule.type === "exclude") {
                if (hit) return null
                else continue
              }
            }
          }

          return (
            <li key={index}>
              {external ? (
                <a href={external} target='_blank' rel='noopener noreferrer nofollow'>
                  {label}
                </a>
              ) : (
                <a href={navigation.localize(href)} rel='nofollow'>
                  {label}
                </a>
              )}
            </li>
          )
        })}
      </ul>
    </Root>
  )
}
